/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Odeslat`
};

const da_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Bekræft`
};

const de_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Bestätigen`
};

const en_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Submit`
};

const es_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Validar`
};

const fr_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Valider`
};

const hu_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Küldés`
};

const it_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Conferma`
};

const nl_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Bevestigen`
};

const pl_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Zatwierdź`
};

const pt_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar`
};

const sv_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Bekräfta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const submit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.submit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("submit", locale)
	if (locale === "cs") return cs_submit(inputs)
	if (locale === "da") return da_submit(inputs)
	if (locale === "de") return de_submit(inputs)
	if (locale === "en") return en_submit(inputs)
	if (locale === "es") return es_submit(inputs)
	if (locale === "fr") return fr_submit(inputs)
	if (locale === "hu") return hu_submit(inputs)
	if (locale === "it") return it_submit(inputs)
	if (locale === "nl") return nl_submit(inputs)
	if (locale === "pl") return pl_submit(inputs)
	if (locale === "pt") return pt_submit(inputs)
	return sv_submit(inputs)
};